export default __webpack_public_path__ + "static/media/letter-icon.adaae957.svg";